import * as React from "react";
import classNames from "classnames";
import { MdArrowDropDown, MdCancel, MdErrorOutline } from "react-icons/md";

import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

export const NoOptionsMessage = ({
  selectProps,
  innerProps,
  children
}: {
  selectProps: any;
  innerProps: any;
  children: React.ReactNode;
}) => (
  <Typography
    color="textSecondary"
    className={selectProps.classes.noOptionsMessage}
    {...innerProps}
  >
    {children}
  </Typography>
);

export const inputComponent = ({ inputRef, ...props }: any) => (
  <div ref={inputRef} {...props} />
);

export const Control = ({
  selectProps,
  innerRef,
  children,
  innerProps
}: any) => (
  <TextField
    fullWidth
    variant="outlined"
    className={selectProps.classes.textField}
    label={selectProps.label}
    margin="dense"
    error={selectProps.showError}
    InputLabelProps={{
      shrink: true
    }}
    InputProps={{
      inputComponent,
      inputProps: {
        className: selectProps.classes.input,
        inputRef: innerRef,
        children,
        ...innerProps
      }
    }}
    {...selectProps.textFieldProps}
  />
);

export const Option = ({
  innerRef,
  isFocused,
  isSelected,
  innerProps,
  children,
  selectProps
}: any) => (
  <MenuItem
    buttonRef={innerRef}
    selected={isFocused}
    component="div"
    style={{
      fontWeight: isSelected ? 500 : 400,
      minHeight: 40
    }}
    className={selectProps.classes.option}
    {...innerProps}
  >
    {children}
  </MenuItem>
);

export const Placeholder = ({ selectProps, innerProps, children }: any) => (
  <Typography
    color="textSecondary"
    className={selectProps.classes.placeholder}
    {...innerProps}
  >
    {children}
  </Typography>
);

export const SingleValue = ({
  selectProps,
  innerProps,
  isDisabled,
  children
}: any) => (
  <Typography
    className={classNames(selectProps.classes.singleValue, {
      [selectProps.classes.disabledValue]: isDisabled
    })}
    {...innerProps}
  >
    {children}
  </Typography>
);

export const ValueContainer = ({ selectProps, children }: any) => (
  <div className={selectProps.classes.valueContainer}>{children}</div>
);

export const MultiValue = ({
  children,
  selectProps,
  isFocused,
  isDisabled,
  removeProps,
  data
}: any) =>
  data.isInvalid ? (
    <Chip
      tabIndex={-1}
      label={
        <Grid container spacing={1} alignItems="center">
          <Grid item>
            <MdErrorOutline />
          </Grid>
          <Grid item>{children}</Grid>
        </Grid>
      }
      className={classNames(selectProps.classes.chip, {
        [selectProps.classes.chipFocused]: isFocused,
        [selectProps.classes.chipInvalid]: data.isInvalid
      })}
      onDelete={!isDisabled ? removeProps.onClick : null}
      deleteIcon={<MdCancel />}
    />
  ) : (
    <Chip
      tabIndex={-1}
      label={children}
      className={classNames(selectProps.classes.chip, {
        [selectProps.classes.chipFocused]: isFocused
      })}
      onDelete={!isDisabled ? removeProps.onClick : null}
      deleteIcon={<MdCancel />}
    />
  );

export const Menu = ({ selectProps, innerProps, children }: any) => (
  <Paper square className={selectProps.classes.paper} {...innerProps}>
    {children}
  </Paper>
);

export const DropdownIndicator = ({ selectProps }: any) => {
  return selectProps.options.length > 1 ? (
    <MdArrowDropDown className={selectProps.classes.dropDownIcon} />
  ) : null;
};
